import { Spinner } from 'react-bootstrap'
import { useState } from 'react'
import { Select } from '../Career/Select'
import { salary } from '../../i18n/translatedMessages'

import { translate as translateAreas } from '../../i18n/Library/areasCorrelation.js'
import { translate as translatePosition } from '../../i18n/Library/hierarchicalLevel'
import { translate as translateSubareas } from '../../i18n/Library/subareasTranslate.js'

export function NextStepModal({ onSave, onClose, data, lists, language }) {
	const [values, setValues] = useState({
		area_id: data?.area_id || null,
		subarea: data?.subarea || null,
		level_id: data?.level_id || null,
	})

	const [isSaving, setIsSaving] = useState(false)

	const translatedAreas = lists.areas.map(item => ({
		...item,
		value: translateAreas[language]?.[item.value],
	}))

	const translatedLevels = lists.levels.map(item => ({
		...item,
		value: translatePosition[language][item?.value],
	}))

	const filteredAndTranslatedSubareas = values.area_id
		? lists.subareas
				.filter(subarea => subarea.area === values.area_id)
				.map(item => ({
					...item,
					value: translateSubareas[language][item?.value] || item?.value,
				}))
		: []

	const handleChange = event => {
		const { name, value } = event.target

		setValues(prevValues => ({
			...prevValues,
			[name]: value,
			...(name === 'area_id' && { subarea: null }),
		}))
	}

	const handleSave = async () => {
		setIsSaving(true)
		try {
			await onSave(values)
		} finally {
			setIsSaving(false)
		}
	}

	return (
		<div className='tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-flex tw-items-center tw-justify-center tw-z-50'>
			<div className='tw-bg-white tw-p-6 tw-rounded-lg tw-w-8/12'>
				<h4 className='tw-font-bold'>{salary.carrerIndicatorsBtnDefineNextStep}</h4>

				<div className='tw-flex tw-space-x-4 tw-mt-5'>
					<div className='tw-w-full'>
						<div>Nivel</div>
						<Select placeholder='Nível' list={translatedLevels} name='level_id' value={values.level_id} onChange={handleChange} />
					</div>
					<div className='tw-w-full'>
						<div>Área</div>
						<Select placeholder='Área' list={translatedAreas} value={values.area_id} onChange={handleChange} name='area_id' />
					</div>
				</div>

				<div className='tw-w-full tw-mt-4'>
					<div>Subárea</div>
					<Select placeholder='Subárea' list={filteredAndTranslatedSubareas} value={values.subarea} onChange={handleChange} name='subarea' />
				</div>

				<div className='tw-flex tw-justify-end tw-mt-5 tw-space-x-5'>
					<button
						className='tw-border-purple-500 tw-border tw-bg-white  tw-text-purple-500 tw-px-4 tw-py-2 tw-rounded-full'
						onClick={() => onClose(false)}
						disabled={isSaving}
					>
						{salary.modalDefinitionsBtnCancel}
					</button>
					<button
						className='tw-bg-purple-500 tw-border-none tw-w-[95px] tw-h-[42px] tw-justify-center tw-text-white tw-px-4 tw-py-2 tw-rounded-full tw-flex tw-items-center'
						onClick={handleSave}
						disabled={isSaving}
					>
						{isSaving ? (
							<Spinner animation='border' role='status'>
								<span className='visually-hidden'>Loading...</span>
							</Spinner>
						) : (
							salary.modalDefinitionsBtnSave
						)}
					</button>
				</div>
			</div>
		</div>
	)
}
